import {
  SectionElement,
  defineElement,
  globalOn,
  onClick,
  query,
  queryAll
} from "./chunk-DNDL4K7L.js";
import {
  __decorateClass
} from "./chunk-XS5WIYU5.js";

// src/sections/new-case-studies/new-case-studies.ts
var NewCaseStudies = class extends SectionElement {
  initSwiper() {
    var _a, _b;
    (_b = (_a = this.swiper) == null ? void 0 : _a.swiperInstance) == null ? void 0 : _b.on("slideChange", () => {
      var _a2, _b2, _c;
      this.setActiveDot((_c = (_b2 = (_a2 = this.swiper) == null ? void 0 : _a2.swiperInstance) == null ? void 0 : _b2.realIndex) != null ? _c : 0);
    });
  }
  onDotClick(elm) {
    var _a, _b;
    const index = Number(elm.dataset.index);
    if (!Number.isNaN(index))
      (_b = (_a = this.swiper) == null ? void 0 : _a.swiperInstance) == null ? void 0 : _b.slideTo(index);
  }
  setActiveDot(index) {
    var _a;
    (_a = this.dots) == null ? void 0 : _a.forEach((dot, i) => {
      dot.setAttribute("data-active", String(i === index));
    });
  }
};
__decorateClass([
  query("[data-ncs-swiper]")
], NewCaseStudies.prototype, "swiper", 2);
__decorateClass([
  queryAll("[data-ncs-dot]")
], NewCaseStudies.prototype, "dots", 2);
__decorateClass([
  globalOn("new-case-studies:init")
], NewCaseStudies.prototype, "initSwiper", 1);
__decorateClass([
  onClick("[data-ncs-dot]")
], NewCaseStudies.prototype, "onDotClick", 1);
NewCaseStudies = __decorateClass([
  defineElement("new-case-studies")
], NewCaseStudies);
export {
  NewCaseStudies
};
